import Modal from 'react-bootstrap/Modal';
import './css/modalRemove.css';

export default function ModalRemove(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="p-3 modal-remove">
        <div className="d-flex">
          <h5 style={{}}>Bạn chắc chắn thực hiện hành động này?</h5>
          <span onClick={props.onHide} className="btn p-0  ms-auto">
            <i className="fas fa-times"></i>
          </span>
        </div>
        <p>Hành động này không thể hoàn tác. Phần này sẽ bị xóa.</p>
        <div className="d-flex justify-content-end modal-btn">
          <button onClick={props.onHide} className="btn cancel">
            Hủy
          </button>
          <button onClick={props.onConfirm} className="btn continue">
            Tiếp tục
          </button>
        </div>
      </div>
    </Modal>
  );
}
